import illustration from '../../assets/Greate.svg';
import './ScoreCardSubmittedView.scss';

export function ScoreCardSubmittedView() {
    return (
        <div className="score-card-submitted">
            <div className="score-card-submitted__body">
                <div className="score-card-submitted__content">
                    <h1 className="score-card-submitted__title">Scorecard Submitted</h1>
                    <div className="score-card-submitted__text-block">
                        <p className="score-card-submitted__paragraph">
                            Thank you for completing the supplier scorecard.
                        </p>
                        <p className="score-card-submitted__paragraph">
                            Your responses have been recorded and will form part of the supplier&apos;s final
                            evaluation.
                        </p>
                    </div>
                </div>
                <div className="score-card-submitted__illustration" aria-hidden>
                    <img src={illustration} alt="" />
                </div>
            </div>
        </div>
    );
}
